import type { AudioFormInput } from '../../../audio-form/data/dto/audio-form-input.ts'
import { generateAudioform } from '../../../audio-form/domain/use-cases/generate-audioform.ts'

export interface AudioBufferAndId {
  audioBuffer: AudioBuffer
  id: string
  url: string
}

export const generateSoundDesign = async (
  soundDesignAlias: string,
  duration: number,
  sessionId: string
): Promise<AudioBufferAndId> => {
  const audioFormInput: AudioFormInput = {
    header: {
      version: '2',
    },
    assets: {
      'sound template 0': {
        type: 'soundTemplate',
        soundTemplateAlias: soundDesignAlias,
        segment: 'main',
      },
    },
    production: {
      arrangement: {
        sections: [
          {
            layers: [],
            forcedDuration: duration,
            soundTemplateRef: 'sound template 0',
          },
        ],
      },
      masteringPreset: 'balanced',
    },
    delivery: {
      loudnessPreset: 'spotify',
      encoderPreset: 'mp3',
      public: false,
    },
  }

  const audioForm = await generateAudioform(audioFormInput, sessionId)
  return {
    id: audioForm.id,
    audioBuffer: audioForm.audioBuffer,
    url: audioForm.url,
  }
}
